<template>
  <path
    d="M2 18.7479L2.16331 6.99172L10.0237 2L21.6592 5.10296L22 16.9988L14.2698 22L2 18.7479ZM3.75148 17.4343L13.3396 19.7894L13.2734 10.7574L10.1964 10.0757L10.1515 14.1728L6.63432 14.3976V9.28521L3.84379 8.66982L3.75148 17.4343ZM10.3787 3.66864L4.92544 7.08876L7.19527 7.64497L12.8757 4.27219L10.3787 3.66864ZM16.8166 5.23077L10.9491 8.56568L14.0899 9.33728L19.929 5.9858L16.8166 5.23077Z"
  />
</template>
